;(function( window, document, $, undefined ) {

  'use strict';

	/*
		Some patterns for JS:
		- Immediately-Invoked Function Expression (IIFE)
		http://benalman.com/news/2010/11/immediately-invoked-function-expression/
		- The Module Pattern
		https://addyosmani.com/resources/essentialjsdesignpatterns/book/#modulepatternjavascript
		- Revealing Module Pattern
		https://addyosmani.com/resources/essentialjsdesignpatterns/book/#revealingmodulepatternjavascript
		- Locaweb Style
		http://opensource.locaweb.com.br/locawebstyle/documentacao/praticas/javascript/
		- Browser Diet
		https://browserdiet.com/
	*/

	// DOM is ready
	$(function(){

    // Variables
    var $body = $('body');

    //* GENERAL
    // Prevent Default Click in #
    $('.site-header').on('click', 'a[href="#"]', function(e){
      e.preventDefault();
    });

    // Btn Back to top
    callsource.btns.btnBackToTop();

    //* HEADER
    // Insert btn menu
    callsource.menu.insertBtnMainMenu();

    // Btn menu toggle
    callsource.menu.btnMenuToggle();

    // Submenu
    callsource.menu.submenuEffect();

    // Contact Menu
    callsource.menu.menuContact();

    $('.carousel-content').slick({
      infinite: false,
      dots: true
    });


    //* FOOTER
    // Widgets Group
    callsource.footer.widgetsGroup();

    // Form Footer Position
    callsource.footer.formPosition();
    $(window).resize(function(){
      callsource.footer.formPosition();
    });


    //* CONTENT
    // Btn Scroll in Hero Banner / Home
    callsource.btns.addBtnScroll( $('.hero-banner') );
    callsource.btns.btnScrollAnimation(  $('.btn-scroll'), $('.block-content-highlights'));

    // Content Highlights
    callsource.contentHighlights.addClasses();
    callsource.contentHighlights.adjustmentsWidth();
    $(window).resize(function(){
      callsource.contentHighlights.adjustmentsWidth();
    });

    // Change position Elements on Mobile
    callsource.positionElements.mobile( $('.change-position-mobile'), '.vc_inner' );

    // Content Animation - Image
    callsource.contentAnimation.toggleEffectScroll( $('.content-highlight .wpb_single_image'), '.content-highlight',
      function( $this ){ $this.addClass('wpb_start_animation animated'); },
      function( $this ) { $this.removeClass('wpb_start_animation animated'); }
    );

    callsource.contentAnimation.toggleEffectScroll( $('.content-highlight .square-svg-gray'), '.content-highlight',
      function( $this ){ $this.addClass('wpb_start_animation animated wpb_top-to-bottom top-to-bottom'); },
      function( $this ) { $this.removeClass('wpb_start_animation animated wpb_top-to-bottom top-to-bottom'); }
    );

    // Content Animation - Odometer
    $('.content-highlight .odometer').each(function(){
      var $this = $(this);
      var $el = $this[0];
      if( $this.data('format') == 'points' ) {
        var od = new Odometer({
          el: $el,
          format: '(.ddd)'
        });
      }
    });
    callsource.contentAnimation.toggleEffectScroll( $('.content-highlight .odometer'), '.content-highlight',
      function( $this ){ $this.html( $this.data('number')); },
      function( $this ) { $this.html( 0 ); }
    );

    // Text Animation
    callsource.typedText.animation( $('.animated-text') );

    // Column Stretch
    callsource.columnStretch.background();

    // Column Stretch
    callsource.internBanner.background();

    // Info Box height
    callsource.adjustments.height( $('.info-box-text:not(.large)').find('.aio-icon-description') );
    $(window).resize(function(){
      callsource.adjustments.height( $('.info-box-text:not(.large)').find('.aio-icon-description') );
    });

    // Btns Groups Width
    callsource.adjustments.width( $('.btns-grid-group').find('button') );
    $(window).resize(function(){
      callsource.adjustments.width( $('.btns-grid-group').find('button') );
    });


    // Team List
    callsource.teamList.init();

    // Btn Skip
    callsource.btns.btnScrollAnimation(  $('.btn-skip').find('a'), $('.target-skip'));

    // Solutions Carousel
    if( $('.solutions-carousel-content').length > 0 ) {

      $('.solutions-highlights-item').each(function(){
        $(this).find('.solutions-carousel-content').wrapAll('<div class="solutions-carousel"></div>');
      });

      $('.solutions-highlights').after('<div class="solutions-carousel-container"></div>');
      $('.solutions-carousel-container').append('<button type="button" class="solutions-carousel-btn-back"><i class="icon-arrow-left"></i> All Solutions</a>');

      $('.solutions-carousel-btn').click(function(e){
        e.preventDefault();

        var $this = $(this);
        var $copyCarousel = $this.closest('.solutions-highlights-item').find('.solutions-carousel').clone();
        var $carouselContainer = $('.solutions-carousel-container');

        $('.solutions-highlights').hide();

        $carouselContainer.find('.solutions-carousel').remove();
        $carouselContainer.append( $copyCarousel );
        $carouselContainer.fadeIn();

        setTimeout(function(){
          $('.solutions-carousel-container').find('.solutions-carousel').slick({
            dots: true,
            infinite: false
          });
        }, 10);

        $("html, body").animate({ scrollTop: $('.solutions-carousel-container').offset().top - 165 }, 500);
      });

      $('.solutions-carousel-btn-back').click(function(){
        $('.solutions-carousel-container').hide();
        $('.solutions-highlights').fadeIn();
      });
    }


	});

})( window, document, jQuery );
